import type { LegalCaseFields } from '../types/legalCase';
import { createContext,useContext,type ReactNode } from 'react';

export interface CaseData extends LegalCaseFields {
    id: number | string;
    vault_item_id?: number;
    data: LegalCaseFields;
    folder_id?: number | null;
}

export interface Folder {
    id: number;
    nume: string;
    prompt_user_request?: string | null;
    prompt_fact_situation?: string | null;
    created_at: string;
    is_shared?: boolean; // If true, it's shared with me
    owner_name?: string; // If shared
    permission?: 'read' | 'write'; // If shared
}

export interface ToastMessage {
    message: string;
    type: 'success' | 'error' | 'info';
}

export interface DosarContextType {
    items: CaseData[];
    folders: Folder[];
    foldersSharedWithMe: Folder[]; // Separate list for shared folders
    currentFolderId: number | null;
    addToDosar: (item: CaseData, folderId?: number | null) => Promise<void>;
    removeFromDosar: (id: number | string) => Promise<void>;
    isCaseInDosar: (id: number | string) => boolean;
    isDrawerOpen: boolean;
    toggleDrawer: () => void;

    // Folder Actions
    loadFolders: () => Promise<void>;
    createNewFolder: (nume: string) => Promise<void>;
    updateFolder: (id: number, data: { nume?: string; prompt_user_request?: string; prompt_fact_situation?: string }) => Promise<void>;
    removeFolder: (id: number) => Promise<void>;
    openFolder: (id: number | null) => void;

    toast: ToastMessage | null;
    hideToast: () => void;
    showToast: (message: string, type: 'success' | 'error' | 'info') => void;
}

export const DosarContext = createContext<DosarContextType | undefined>(undefined);

export const useDosar = () => {
    const context = useContext(DosarContext);
    if (!context) {
        throw new Error('useDosar must be used within a DosarProvider');
    }
    return context;
};

export interface DosarProviderProps {
    children: ReactNode;
}
